import { AspenCandidatesService } from '@om1/aspen-api/codegen/client/services/AspenCandidatesService'
import { useSnackbar } from 'notistack'
import { useCallback } from 'react'

type StatusReasonText = string

export const useUpdateCandidateStatus = () => {
    const { enqueueSnackbar } = useSnackbar()

    const updateCandidateStatus = useCallback(
        async (candidateId: string, newStatus: string, reasonText?: StatusReasonText | null) => {
            try {
                const reasonPayload =
                    newStatus === 'declined'
                        ? { declineReasonText: reasonText ?? null }
                        : newStatus === 'screen_failure'
                        ? { screenFailureReason: reasonText ?? null }
                        : {}

                await AspenCandidatesService.patchCandidatesCandidateIdPatch({
                    candidateId,
                    requestBody: {
                        id: candidateId,
                        status: newStatus as any, // Type assertion needed due to strict typing
                        ...(reasonText !== undefined ? reasonPayload : {})
                    }
                })

                enqueueSnackbar('Status updated successfully', { variant: 'success' })
            } catch (error) {
                console.error('Failed to update candidate status:', error)
                enqueueSnackbar('Failed to update status', { variant: 'error' })
                throw error
            }
        },
        [enqueueSnackbar]
    )

    return { updateCandidateStatus }
}
